import { render, staticRenderFns } from "./ChannelUp.vue?vue&type=template&id=6c3ca6ea"
import script from "./ChannelUp.vue?vue&type=script&lang=js"
export * from "./ChannelUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../deps/0/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports